import makeStyles from '@mui/styles/makeStyles';

const financialHomePageStyles = makeStyles((theme) => ({
    columnStyle: {
        flexGrow: 1,
        width: '50%',
        minWidth: '300px',
        maxWidth: '600px'
    },
    container: {
        padding: theme.spacing(0, 2.3)
    }
}));

export default financialHomePageStyles;
